"use client";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { ButtonGroup } from "ui/core/button-group";

import {
  WhaleInterestFactorKey,
  getWhaleInterestFactors,
} from "../data/factors";

type Props = {
  symbol: string;
  currentFactor?: WhaleInterestFactorKey;
};

export const FactorButtons = ({
  symbol,
  currentFactor = "instOwnshp",
}: Props) => {
  const { t } = useLang();
  const factors = getWhaleInterestFactors({ t, symbol });
  const { updateQuery } = useUpdateQuery();

  const onClick = (value: string) => {
    updateQuery({ name: "factor", value });
  };

  return (
    <div className="hidden sm:flex">
      <ButtonGroup
        value={currentFactor}
        options={factors}
        onButtonClick={onClick}
      />
    </div>
  );
};
